<template>
    <modal-layout
        :hide-closer="true"
        prevent-backdrop-click
        title="Dokončiť registráciu"
        @before-close="preventLeavingWithoutSubmitting"
    >
        Pred pokračovaním je potrebné dokončit tvoju registráciu.

        <template #footer>
            <div class="flex justify-between">
                <CButton icon="back" @click="cancel()"> Späť </CButton>
                <CButton variant="secondary" @click="submit()">
                    Dokončiť
                    <span class="hidden sm:inline-block">registráciu</span>
                </CButton>
            </div>
        </template>
    </modal-layout>
</template>

<script setup lang="ts">
const props = defineProps<{
    routePath?: string
}>()

const emit = defineEmits<{
    (e: 'close'): void
}>()

const router = useRouter()
const route = useRoute()
const isSubmitting = ref(false)

function submit() {
    isSubmitting.value = true
    emit('close')

    router.push({
        name: 'auth-registration',
        query: { redirect: route.fullPath }
    })
    isSubmitting.value = false
}

function cancel() {
    isSubmitting.value = true
    emit('close')
    if (props.routePath) {
        router.push(props.routePath)
    } else {
        router.go(-1)
    }
    isSubmitting.value = false
}

function preventLeavingWithoutSubmitting(close: () => void) {
    if (isSubmitting.value) {
        close()
    }
}
</script>